import type {Action} from "redux";
import type AuthenticationToken from "../../authentication/objects/AuthenticationToken";

export const SET_AUTHENTICATION_TOKEN = Symbol("AUTHENTICATION_TOKEN");
export const REMOVE_AUTHENTICATION_TOKEN = Symbol("REMOVE_AUTHENTICATION_TOKEN");

export interface IAuthenticationState {
    authenticationToken?: AuthenticationToken;
}

export interface IAuthenticationReducerAction extends Action<symbol> {
    authenticationToken?: AuthenticationToken;
}

const initialState: IAuthenticationState = {
    authenticationToken: undefined
};

export default function AuthenticationReducer(state: IAuthenticationState = initialState, action: IAuthenticationReducerAction): IAuthenticationState {
    switch(action.type) {
        case SET_AUTHENTICATION_TOKEN:
            return {
                ...state,
                authenticationToken: action.authenticationToken!
            };
        case REMOVE_AUTHENTICATION_TOKEN:
            return {
                ...state,
                authenticationToken: undefined
            };
        default:
            return state;
    }
}